<template>
    <div class="app-header bg-sky-600">
        <layout-contained>
            <div class="py-3 text-2xl">
                <nuxt-link :aria-label="$config.public.siteName" to="/">
                    <picture>
                        <source :srcset="$config.public.images + $config.public.siteLogoAvif" type="image/avif" media />
                        <source :srcset="$config.public.images + $config.public.siteLogoWebp" type="image/webp" media />
                        <img :src="$config.public.images + $config.public.siteLogo" width="174" height="46" alt />
                    </picture>
                </nuxt-link>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppHeader',
};
</script>
